import React, { useState } from 'react';

import './index.module.less';

import Item from './Item';

interface IProps {
  items: any[] | null;
  onSelectItem: (item: any, isSearch?: boolean) => void;
  selectedLocation: any;
  onShowSearch: () => void;
}

const List = (props: IProps) => {
  const { items, selectedLocation, onSelectItem, onShowSearch } = props;
  const [isExpand, setExpand] = useState(false);

  const renderLocations = (): JSX.Element | JSX.Element[] => {
    let Items = null;
    if (items?.length) {
      const tempItems = isExpand ? items : items.slice(0, 1);
      Items = tempItems.map((item: any) => {
        return (
          <Item
            item={item}
            onSelect={onSelectItem}
            selectItem={selectedLocation}
            style={isExpand ? {} : { border: 'none'}}
          />
        );
      });
    } else if (items && items.length) {
      Items = <div styleName="empty">无结果</div>;
    }
    return Items;
  };

  return (
    <div
      className="flex"
      styleName="modal"
      style={{ height: isExpand ? '70%' : 'auto', paddingTop: 0 }}
    >
      <div
        className="flex flex-center"
        styleName="expand-btn"
        onClick={() => setExpand(!isExpand)}
      >
        <i
          className="iconfont icon-dibudanchuangzhankai"
          style={isExpand ? { transform: 'rotate(180deg)' } : {}}
        />
      </div>
      <div
        className="flex"
        styleName="search-btn-wrapper"
        onClick={onShowSearch}
      >
        <i className="iconfont icon-sousuo" styleName="input-icon" />
        <div styleName="search-btn">搜索地点名称</div>
      </div>
      <div styleName="list">{renderLocations()}</div>
    </div>
  );
};

export default List;
